<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <span>提交状态：</span>
            <el-select
              v-model="listQuery.SubmitState"
              placeholder="请选择"
              @change="submitStateChange"
            >
              <el-option label="全部" :value="-1"> </el-option>
              <el-option label="未提交" :value="0"> </el-option>
              <el-option label="已提交" :value="1"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">返回投票列表</el-button>
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportData()"
          >
            导出
          </el-button>
        </div>
      </div>
      <h2 style="text-align: center">
        <div v-html="voteDetail.VoteName + '（明细）'"></div>
      </h2>
      <div class="table-block" style="border-top: 0px">
        <el-table
          :data="voteDetail.Items"
          highlight-current-row
          style="width: 100%"
        >
          <el-table-column
            type="index"
            :index="indexMethod"
            label="序号"
            width="90"
          ></el-table-column>
          <el-table-column
            property="UserName"
            label="投票人"
            width="120"
            align="left"
          >
          </el-table-column>
          <el-table-column
            label="项目"
            min-width="300"
            align="left"
            key="QuestionStem"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.QuestionStem }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="填选内容"
            min-width="200"
            align="left"
            key="Answer"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.Answer }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination_box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[20, 30, 50, 100, 300, 500]"
            :page-size="listQuery.MaxResultCount"
            :layout="pagination_layout"
            :total="listTotalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import voteManageApi from '../../../../../api/vote/voteManage'
export default {
  name: 'Details',
  components: {
  },
  data () {
    return {
      listQuery: {
        VoteId: null,
        KeyWord: null,
        SkipCount: 0,
        MaxResultCount: 20,
        SubmitState: -1
      },
      listTotalCount: 0,
      currentPage: 1,
      voteDetail: {
        Items: []
      },
      pagination_layout: 'prev, pager, next'
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    },
    submitStateChange: function () {
      this.listQuery.SkipCount = 0
      this.getVoteQADetails()
    },
    refresh: function () {
      this.getVoteQADetails()
    },
    getVoteQADetails: function () {
      const _this = this
      const openLoading = _this.openLoading('', '.main_body')
      _this.listQuery.VoteId = _this.$route.params.qid
      voteManageApi.getVoteQADetails(_this.listQuery).then(data => {
        _this.voteDetail = data
        _this.listTotalCount = data.TotalCount
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    indexMethod (index) {
      return this.listQuery.SkipCount + index + 1
    },
    handleSizeChange (val) {
      this.listQuery.MaxResultCount = val
      this.getVoteQADetails()
    },
    handleCurrentChange (val) {
      this.listQuery.SkipCount = (val - 1) * this.listQuery.MaxResultCount
      this.getVoteQADetails()
    },
    exportData: function () {
      const openLoading = this.openLoading('正在导出…')
      voteManageApi.exportVoteQADetails({
        VoteId: this.listQuery.VoteId,
        SubmitState: this.listQuery.SubmitState
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '投票明细'
        fileName = this.voteDetail.VoteName + ' - 投票明细'
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    }
  },
  computed: {

  },
  created () {
    this.getVoteQADetails()
    this.getCurrentUserRole()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
</style>
